import React, { Component, createRef } from 'react';
import Rating from 'react-rating';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage, getServerTime } from '../../../util/responseUtil';
import { encodeHtml } from '../../../util/htmlSpecialChar';
import { targetResolutionTime, targetResponseTime, timeFrom, timeFromNow } from '../../../util/date';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../../constants/roleCategoryConstant';
import { STATUS_TICKET_CONSTANT } from '../../../constants/statusTicketConstant';
import API_TICKET_LIST from '../../../api/apiTicketList';
import API_SOLUTION from '../../../api/apiSolution';
import BackButton from '../../../components/Common/BackButton';
import TicketPhoneSideInside from '../../../components/TicketList/TicketPhoneSideInside';
import TicketNote from '../../../components/TicketDetail/TicketNote';
import TicketEscalation from '../../../components/TicketDetail/TicketEscalation';
import TicketClose from '../../../components/TicketDetail/TicketClose';
import TicketURL from '../../../components/TicketDetail/TicketURL';
import TicketVersion from '../../../components/TicketDetail/TicketVersion';
import TicketRedmine from '../../../components/TicketDetail/TicketRedmine';
import TicketReopen from '../../../components/TicketDetail/TicketReopen';
import TicketDelete from '../../../components/TicketDetail/TicketDelete';
import TicketIssueCategory from '../../../components/TicketDetail/TicketIssueCategory';
import TicketRootCause from '../../../components/TicketDetail/TicketRootCause';
import IconAddNoteGray from '../../../assets/icons/IconAddNoteGray';
import IconIssueDescription from '../../../assets/icons/IconIssueDescription';
import IconSolutionGray from '../../../assets/icons/IconSolutionGray';
import IconStarEmpty from '../../../assets/icons/IconStarEmpty';
import IconStarFull from '../../../assets/icons/IconStarFull';
import TicketComplaintIssue from '../../../components/TicketDetail/TicketComplaintIssue';
import TicketAttachment from '../../../components/TicketDetail/TicketAttachment';
import TicketExportChat from '../../../components/TicketDetail/TicketExportChat';
import DropdownFilter from '../../../components/Common/DropdownFilter';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    TICKET_LIST_ALL_CUSTOMER_NAME_UPDATE,
    TICKET_LIST_ALL_CUSTOMER_NAME_UPDATE_ASSIGNEE
} from '../../../constants/menuPermissionConstant';

class TicketDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticketDetail: {},
            ticketNote: [],
            serverTime: '',
            canEscalate: true,
            showCustomerPrincipalModal: false,
            principal: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                id: 0,
                reset: false
            },
            customer: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                id: 0,
                reset: false
            },
            showRateDetail: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getDataDetailNote = id => {
        // Ticket All
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                // CSO
                API_TICKET_LIST.getDataDetailNoteAllCSO(id, this.props.token)
                    .then(res => { this.setState({ ticketNote: getContent(res) }); })
                    .catch(errorHandler(this.props.handleLogout, this.props.history))
            } else {
                // Non CSO
                API_TICKET_LIST.getDataDetailNoteAllNonCSO(id, this.props.token)
                    .then(res => { this.setState({ ticketNote: getContent(res) }); })
                    .catch(errorHandler(this.props.handleLogout, this.props.history))
            }
        }
        // Ticket New
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) {
            API_TICKET_LIST.getDataDetailNoteNew(id, this.props.token)
                .then(res => { this.setState({ ticketNote: getContent(res) }); })
                .catch(errorHandler(this.props.handleLogout, this.props.history))
        }
        // Ticket Member
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)) {
            API_TICKET_LIST.getDataDetailNoteMember(id, this.props.token)
                .then(res => { this.setState({ ticketNote: getContent(res) }); })
                .catch(errorHandler(this.props.handleLogout, this.props.history))
        }
        // Ticket Solution
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            API_TICKET_LIST.getDataDetailNoteSolution(id, this.props.token)
                .then(res => { this.setState({ ticketNote: getContent(res) }); })
                .catch(errorHandler(this.props.handleLogout, this.props.history))
        }
    }

    getTicketDetail = () => {
        // Ticket All
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            // CSO
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                return API_TICKET_LIST.getDetailDataTicketAllCSO(this.props.match.params.id, this.props.token)
                    .then(res => {
                        if (this._isMounted) {
                            this.setState({
                                ticketDetail: getContent(res),
                                serverTime: getServerTime(res)
                            });
                            this.getDataDetailNote(getContent(res).id);
                        }
                    }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                        if (err.response.data.nexsoft.payload.status.message === "Data ticket tidak diketahui") {
                            this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                            setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                        }
                    }))
            }
            // Non CSO
            return API_TICKET_LIST.getDetailDataTicketAllNonCSO(this.props.match.params.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            ticketDetail: getContent(res),
                            serverTime: getServerTime(res)
                        });
                        this.getDataDetailNote(getContent(res).id);
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    if (err.response.data.nexsoft.payload.status.message === "Data ticket tidak diketahui") {
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                        setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                    }
                }))
        }
        // Ticket New
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                // CSO
                return API_TICKET_LIST.getDetailTicketUnassigned(this.props.match.params.id, this.props.token)
                    .then(res => {
                        if (this._isMounted) {
                            this.setState({
                                ticketDetail: getContent(res),
                                serverTime: getServerTime(res)
                            });
                            this.getDataDetailNote(getContent(res).id);
                        }
                    }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                        if (err.response.data.nexsoft.payload.status.message === "Data ticket tidak diketahui") {
                            this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                            setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                        }
                    }))
            }
            // Non CSO
            return API_TICKET_LIST.getDetailTicketAssignedUnassigned(this.props.match.params.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            ticketDetail: getContent(res),
                            serverTime: getServerTime(res)
                        });
                        this.getDataDetailNote(getContent(res).id);
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    if (err.response.data.nexsoft.payload.status.message === "Data ticket tidak diketahui") {
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                        setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                    }
                }))
        }
        // Ticket Member
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)) {
            return API_TICKET_LIST.getDetailTicketMember(this.props.match.params.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            ticketDetail: getContent(res),
                            serverTime: getServerTime(res)
                        });
                        this.getDataDetailNote(getContent(res).id);
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    if (err.response.data.nexsoft.payload.status.message === "Data ticket tidak diketahui") {
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                        setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                    }
                }))
        }
        // Ticket Solution
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            return API_SOLUTION.getDetailDataTicketSolution(this.props.match.params.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            ticketDetail: getContent(res),
                            serverTime: getServerTime(res)
                        });
                        this.getDataDetailNote(getContent(res).id);
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    if (err.response.data.nexsoft.payload.status.message === "Data ticket tidak diketahui") {
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                        setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                    }
                }))
        }
    }

    getListCustomer = () => {
        API_TICKET_LIST.getListDistributor(this.state.customer.page, this.state.customer.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let customerList = getContent(res).map(customer => ({
                        value: customer.user_nexcare_id,
                        label: customer.customer_name,
                        id: customer.id
                    }))
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: customerList
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchCustomer = keyword => {
        API_TICKET_LIST.getSearchDistributor(this.state.customer.page, this.state.customer.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let customerList = getContent(res).map(customer => ({
                        value: customer.user_nexcare_id,
                        label: customer.customer_name,
                        id: customer.id
                    }))
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: customerList
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListPrincipal = id => {
        if (!id) id = this.state.customer.id
        API_TICKET_LIST.getListPrincipal(this.state.principal.page, this.state.principal.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let principalList = getContent(res).map(principal => ({
                        value: principal.user_nexcare_id,
                        label: principal.customer_name
                    }))
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchPrincipal = keyword => {
        API_TICKET_LIST.getSearchPrincipal(this.state.principal.page, this.state.principal.limit, keyword, this.state.customer.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let principalList = getContent(res).map(principal => ({
                        value: principal.user_nexcare_id,
                        label: principal.customer_name
                    }))
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCanEscalate = data => {
        this.setState({ canEscalate: data });
    }

    handleOpenCustomerPrincipal = () => {
        this.setState({ showCustomerPrincipalModal: true });
        this.getListCustomer();
    }

    handleCloseCustomerPrincipal = () => {
        this.setState({ showCustomerPrincipalModal: false });
        this.handleInitiatePrincipal();
        this.handleInitiateCustomer();
    }

    handleChangeCustomer = data => {
        this.setState({
            customer: {
                ...this.state.customer,
                value: data.value,
                id: data.id
            }
        });
        this.getListPrincipal(data.id);
    }

    handleChangePrincipal = data => {
        this.setState({
            principal: {
                ...this.state.principal,
                value: data.value,
                id: data.id
            }
        });
    }

    handleInitiatePrincipal = () => {
        this.setState({
            principal: {
                ...this.state.principal,
                data: [],
                value: 0,
                id: 0,
                reset: true
            }
        });
    }

    handleInitiateCustomer = () => {
        this.setState({
            customer: {
                ...this.state.customer,
                data: [],
                value: 0,
                id: 0,
                reset: true
            }
        });
    }

    handleResetPrincipal = () => {
        this.setState({
            principal: {
                ...this.state.principal,
                reset: false
            }
        });
    }

    handleResetCustomer = () => {
        this.setState({
            customer: {
                ...this.state.customer,
                reset: false
            }
        });
    }

    handleEditCustomerPrincipal = () => {
        const data = {
            customer_id: this.state.customer.value,
            principal_id: this.state.principal.value,
            updated_at: this.state.ticketDetail.updated_at
        }

        API_TICKET_LIST.putDataUpdateCustomerName(data, this.state.ticketDetail.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showSuccessAlert: true,
                        showCustomerPrincipalModal: false,
                    });
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.getTicketDetail();
                        this.handleInitiatePrincipal();
                        this.handleInitiateCustomer();
                    }, 1500);
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    statusTicket = status => {
        if (status === STATUS_TICKET_CONSTANT.UNASSIGNED) return 'Unassigned';
        if (status === STATUS_TICKET_CONSTANT.ASSIGNED) return 'Assigned';
        if (status === STATUS_TICKET_CONSTANT.IN_PROGRESS) return 'In-Progress';
        if (status === STATUS_TICKET_CONSTANT.ON_HOLD) return 'On-Hold';
        if (status === STATUS_TICKET_CONSTANT.RESOLVED) return 'Resolved';
        if (status === STATUS_TICKET_CONSTANT.CLOSED) return 'Closed';
        if (status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION) return 'Under Observation';
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.state.ticketDetail.assignee_id) return false
        return true;
    }

    handleRateDetail = e => {
        if (this.rateButtonRef && this.rateDetailRef && !this.rateButtonRef.current.contains(e.target) && !this.rateDetailRef.current.contains(e.target)) {
            this.setState({ showRateDetail: false });
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.rateButtonRef = createRef();
        this.rateDetailRef = createRef();

        this.getTicketDetail();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showRateDetail !== this.state.showRateDetail) {
            if (this.state.showRateDetail) {
                document.addEventListener('click', this.handleRateDetail);
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;

        document.removeEventListener('click', this.handleRateDetail);
    }

    render() {
        return (
            <>
                <div className={!this.state.ticketDetail.id ? "hidden" : "header flex items-center mb-5"}>
                    <BackButton />
                    <TicketNote data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                    <TicketAttachment data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                    <TicketComplaintIssue data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                    <TicketEscalation data={this.state.ticketDetail} canEscalate={this.state.canEscalate} />
                    <TicketClose data={this.state.ticketDetail} />
                    <TicketURL data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                    <TicketVersion data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                    <TicketRedmine data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                    <TicketReopen data={this.state.ticketDetail} getTicketDetail={this.getTicketDetail} />
                    <TicketDelete data={this.state.ticketDetail} />
                    <TicketExportChat data={this.state.ticketDetail} />
                </div>
                <div className={!this.state.ticketDetail.id ? "hidden" : "body flex calculate-layout-button"}>
                    <div className="left w-9/12 bg-white rounded-md px-5 py-3 mr-5 overflow-y-auto relative">
                        <div className="border-b-2 border-gray pb-3">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className={this.state.ticketDetail.status + " flex justify-center items-center text-center text-white text-sm rounded-md capitalize w-24 py-2 mr-3"}>
                                        {this.statusTicket(this.state.ticketDetail.status)}
                                    </div>
                                    <div className="text-gray-600">
                                        <span>
                                            {this.state.ticketDetail.principal} | {this.state.ticketDetail.ticket_no} | {this.state.ticketDetail.percentage}% {this.state.ticketDetail.assign_type !== '' && ' | ' + this.state.ticketDetail.assign_type}
                                            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_CUSTOMER_NAME_UPDATE, TICKET_LIST_ALL_CUSTOMER_NAME_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                                {
                                                    this.checkCustomerServiceAssignee() && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) &&
                                                    <FontAwesomeIcon icon={faEdit} className="text-lightblue cursor-pointer ml-3" id="btnopencustomerprincipal" onClick={() => this.handleOpenCustomerPrincipal()} />
                                                }
                                            </CheckPermissionComponent>
                                        </span>
                                        <div className="flex items-center">
                                            <p className="font-bold w-max max-w-xs truncate mr-3" title={this.state.ticketDetail.issue_title}>{this.state.ticketDetail.issue_title}</p>
                                            <div className={this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.RESOLVED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.CLOSED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION ? "hidden" : "flex items-center"}>
                                                <Rating
                                                    initialRating={this.state.ticketDetail.rate}
                                                    emptySymbol={<IconStarEmpty />}
                                                    fullSymbol={<IconStarFull />}
                                                    readonly
                                                />
                                                {this.state.ticketDetail.rate === 0 ? <p className="text-xs text-gray-400 ml-3">Belum ada ulasan</p> : <p className="text-xs font-bold ml-3">{this.state.ticketDetail.rate}/5</p>}
                                                <p className={this.state.ticketDetail.rate === 0 ? "hidden" : "text-xs text-darkblue cursor-pointer select-none ml-3"} onClick={() => this.setState({ showRateDetail: !this.state.showRateDetail })} ref={this.rateButtonRef}>Lihat Ulasan</p>
                                            </div>
                                            <div className={this.state.showRateDetail ? "relative inline-block z-50" : "hidden"} ref={this.rateDetailRef}>
                                                <div className="origin-top-right absolute -right-32 mt-5 w-80 rounded shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none p-3">
                                                    <div className="flex items-center">
                                                        <div className="bg-darkblue text-white flex items-center justify-center rounded-full font-bold box-lg">{this.state.ticketDetail.customer?.charAt(0)}</div>
                                                        <div className="ml-2">
                                                            <p className="font-bold">{this.state.ticketDetail.customer}</p>
                                                            <div className="flex items-center">
                                                                <Rating
                                                                    initialRating={this.state.ticketDetail.rate}
                                                                    emptySymbol={<IconStarEmpty />}
                                                                    fullSymbol={<IconStarFull />}
                                                                    readonly
                                                                />
                                                                <p className="text-xs font-bold ml-3">{this.state.ticketDetail.rate + '/5'}</p>
                                                                <p className="text-xs text-gray-500 ml-3">{moment.utc(this.state.ticketDetail.rated_at).format('DD/MM/YYYY')}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.ticketDetail.feedback !== '' || this.state.ticketDetail.feedback_description !== ''
                                                            ? <div className="mt-3">
                                                                <p className="font-medium whitespace-pre-wrap">{this.state.ticketDetail.feedback}</p>
                                                                <p className="mt-1">{this.state.ticketDetail.feedback_description}</p>
                                                            </div>
                                                            :
                                                            <p className="mt-3">Belum ada ulasan</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <p className="text-sm my-0.5"><span className="capitalize">{this.state.ticketDetail.customer} | {this.state.ticketDetail.tracker}</span> | Waktu dibuat {moment.utc(this.state.ticketDetail.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                        <div className="flex text-sm my-0.5">
                                            <p className="truncate mr-1">PIC {this.state.ticketDetail.pic_name}</p>
                                            <p className="truncate">{this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.UNASSIGNED && ' | CS ' + this.state.ticketDetail.cs} | Operator {this.state.ticketDetail.tracker === 'grochat' ? 'NexCare Mobile - ' + this.state.ticketDetail.operator_name : this.state.ticketDetail.operator_name}</p>
                                        </div>
                                        <p className="text-sm my-0.5">
                                            {
                                                this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.RESOLVED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.CLOSED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                                                    ? `Waktu diperbaharui ${moment.utc(this.state.ticketDetail.updated_at).format('DD/MM/YYYY HH:mm')}` : ''
                                            }
                                            {
                                                this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.RESOLVED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.CLOSED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                                                    ? this.state.ticketDetail.status === STATUS_TICKET_CONSTANT.ASSIGNED
                                                        ? targetResponseTime(this.state.ticketDetail.response_time_left.target)
                                                        : timeFromNow(this.state.ticketDetail.open_at, this.state.serverTime) !== '' ? ' | Direspon dalam ' + timeFrom(this.state.ticketDetail.created_at, this.state.ticketDetail.open_at) : ''
                                                    : `Waktu respon ${moment.utc(this.state.ticketDetail.open_at).format('DD/MM/YYYY HH:mm')}`
                                            }
                                            {
                                                this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.RESOLVED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.CLOSED && this.state.ticketDetail.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                                                    ? targetResolutionTime(this.state.ticketDetail.resolution_time_left)
                                                    : ' | Diselesaikan dalam ' + timeFrom(this.state.ticketDetail.open_at, this.state.ticketDetail.close_at)
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center items-end text-gray-700 max-w-md truncate text-sm">
                                    <div className="flex items-center capitalize">{this.state.ticketDetail.priority} <div className="rounded-full h-3 w-3 ml-1 mr-0.5" style={{ backgroundColor: this.state.ticketDetail.color }}></div></div>
                                    <TicketRootCause data={this.state.ticketDetail} refresh={this.getTicketDetail} />
                                    <TicketIssueCategory data={this.state.ticketDetail} refresh={this.getTicketDetail} canEscalate={this.handleCanEscalate} />
                                </div>
                            </div>
                            <div className={this.state.ticketDetail.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || this.state.ticketDetail.status === STATUS_TICKET_CONSTANT.ON_HOLD ? "solution px-10 py-3 bg-nexcarewhite2 rounded-lg mt-3" : "hidden"}>
                                <p><span className="font-medium">Nomor Bug</span> {this.state.ticketDetail.no_redmine === '' ? ' -' : this.state.ticketDetail.no_redmine}</p>
                            </div>
                            <div className={this.state.ticketDetail.solution ? "solution p-3 bg-nexcarewhite2 rounded-lg mt-3" : "hidden"}>
                                <div className="flex">
                                    <div className="mt-1">
                                        <IconSolutionGray />
                                    </div>
                                    <div className="ml-2">
                                        <p className="font-bold text-gray-600">Solusi</p>
                                    </div>
                                </div>
                                <div className="text-sm ml-12 my-3" dangerouslySetInnerHTML={{ '__html': encodeHtml(this.state.ticketDetail.solution) }} />
                                <div className="text-gray-700 text-sm ml-12 my-3">
                                    <div className="mb-3"><b>Penyebab Masalah</b> {this.state.ticketDetail.root_cause === '' ? ' -' : this.state.ticketDetail.root_cause}</div>
                                    <div><b>Versi Rilis</b> {this.state.ticketDetail.release_version === '' ? ' -' : this.state.ticketDetail.release_version}</div>
                                    <div>
                                        <b>URL Link</b>
                                        {
                                            this.state.ticketDetail.link_storage === ''
                                                ? ' -'
                                                : <a href={this.state.ticketDetail.link_storage} target="_blank" rel="noreferrer" className="text-darkblue"
                                                > {this.state.ticketDetail.link_storage}</a>
                                        }
                                    </div>
                                    <div><b>Nomor Bug</b> {this.state.ticketDetail.no_redmine === '' ? ' -' : this.state.ticketDetail.no_redmine}</div>
                                </div>
                            </div>
                        </div>
                        <div className="p-3">
                            <div className="flex">
                                <div className="mt-1">
                                    <IconIssueDescription />
                                </div>
                                <div className="ml-2">
                                    <p className="font-bold text-gray-600">Deskripsi Keluhan</p>
                                    <p className="text-xs">({moment.utc(this.state.ticketDetail.created_at).format('ddd, DD MMM YYYY')} di jam {moment.utc(this.state.ticketDetail.created_at).format('HH:mm')})</p>
                                </div>
                            </div>
                            <div className="text-sm ml-12" dangerouslySetInnerHTML={{ '__html': encodeHtml(this.state.ticketDetail.issue_desc) }} />
                        </div>
                        <div className={this.state.ticketNote.length > 0 ? "note p-3" : "hidden"}>
                            <div className="flex">
                                <div className="mt-1">
                                    <IconAddNoteGray />
                                </div>
                                <div className="ml-2">
                                    <p className="font-bold text-gray-600">Note Tambahan</p>
                                    {
                                        this.state.ticketNote.map(note =>
                                            <div key={note.id} className="mb-3">
                                                <p className="text-xs">({moment.utc(note.created_at).format('ddd, DD MMM YYYY')} di jam {moment.utc(note.created_at).format('HH:mm')} oleh {note.created_by})</p>
                                                <p className="text-sm ml-7">{note.value}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right w-3/12 calculate-layout-button">
                        <TicketPhoneSideInside data={this.state.ticketDetail} serverTime={this.state.serverTime} />
                    </div>
                </div>
                <div className={this.state.showCustomerPrincipalModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/4">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnclosecustomerprincipal" onClick={() => this.handleCloseCustomerPrincipal()} />
                            </div>
                            <div>
                                <p className="text-darkblue text-center text-3xl font-medium mt-3">Distributor & Principal</p>
                                <div className="my-8">
                                    <DropdownFilter
                                        id="ddscustomer"
                                        placeholder="Pilih Distributor"
                                        searchPlaceholder="Cari Distributor"
                                        handleChange={this.handleChangeCustomer}
                                        getListData={this.getListCustomer}
                                        getSearchData={this.getSearchCustomer}
                                        data={this.state.customer.data}
                                        reset={this.state.customer.reset}
                                        handleReset={this.handleResetCustomer}
                                    />
                                </div>
                                <div className="my-8">
                                    <DropdownFilter
                                        id="ddsprincipal"
                                        placeholder="Pilih Principal"
                                        searchPlaceholder="Cari Principal"
                                        handleChange={this.handleChangePrincipal}
                                        getListData={this.getListPrincipal}
                                        getSearchData={this.getSearchPrincipal}
                                        data={this.state.principal.data}
                                        reset={this.state.principal.reset}
                                        handleReset={this.handleResetPrincipal}
                                    />
                                </div>
                                <div className="flex justify-center items-center">
                                    <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.handleCloseCustomerPrincipal()}>Batal</button>
                                    <button type="button" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleEditCustomerPrincipal()}>Simpan</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Ubah Nama Distributor & Principal!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketDetail));